import React from 'react';

import { DiamondIcon } from 'src/components/icons';
import { SidebarThemeContext } from 'src/context';
import { white } from 'src/theme/colors';

/**
 *
 * @param props
 * @description Renders diamond icon that represent the advanced feature and is exclusive to higher plans.
 * @returns JSX
 */
export const UpgradeBadge = ({ show = false }) => {
  const { sidebarTextColor } = React.useContext(SidebarThemeContext);
  return show ? (
    <DiamondIcon
      data-testid="upgrade-icon"
      style={{ fontSize: 16, color: sidebarTextColor || white }}
    />
  ) : null;
};
